const breakpointBase = 0;

export { breakpointBase };
